// eslint-disable-next-line no-unused-vars
import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { isFeatureActive } from './featureFlipping.func';

const FeatureFlippingComponent = ({ dataFeatureFlipping, featureName, children }) => {
    if (dataFeatureFlipping && isFeatureActive(dataFeatureFlipping, featureName)) {
        return children;
    }
    return null;
};

FeatureFlippingComponent.propTypes = {
    featureName: PropTypes.string.isRequired,
    dataFeatureFlipping: PropTypes.object,
    children: PropTypes.any,
};

export default connect((state) => {
    const { data: dataFeatureFlipping } = state.featureFlipping;
    return {
        dataFeatureFlipping,
    };
})(FeatureFlippingComponent);
